import { Avatar, Button, Stack, Typography } from "@mui/material";
import { ConfirmationDialog } from "@/components/Dialog/ConfirmationDialog";
import SaveIcon from "@mui/icons-material/Save";

interface UnsavedSegmentChangesDialogProps {
  open: boolean;
  onClose: () => void;
  onDiscard: () => void;
  onSave: () => void;
  isSaving: boolean;
  isCreateMode: boolean;
}

export const UnsavedSegmentChangesDialog: React.FC<
  UnsavedSegmentChangesDialogProps
> = ({ open, onClose, onDiscard, onSave, isSaving, isCreateMode }) => {
  return (
    <ConfirmationDialog
      title="Unsaved Changes"
      open={open}
      actions={
        <Stack
          direction="row"
          spacing={1}
          width="100%"
          justifyContent="space-between"
          padding={2}
        >
          <Button
            color="secondary"
            variant="outlined"
            onClick={onClose}
            disabled={isSaving}
          >
            Cancel
          </Button>
          <Stack direction="row" spacing={1}>
            <Button
              color="secondary"
              variant="outlined"
              onClick={onDiscard}
              disabled={isSaving}
            >
              Discard Changes
            </Button>
            <Button
              sx={{ backgroundColor: "#80cc8d", color: "white" }}
              onClick={onSave}
              disabled={isSaving}
            >
              {isCreateMode ? "Save as New Segment" : "Save Changes"}
            </Button>
          </Stack>
        </Stack>
      }
      onClose={onClose}
    >
      <Stack minWidth={500} alignItems="center" gap={2} padding={2}>
        <Avatar sx={{ bgcolor: "#c8e6c9", color: "black" }}>
          <SaveIcon />
        </Avatar>
        <Typography fontWeight={600} fontSize="20px" mb={1}>
          Save Changes?
        </Typography>
        <Typography>
          {isCreateMode
            ? "Would you like to save your segment before leaving?"
            : "Would you like to save your changes before leaving?"}
        </Typography>
      </Stack>
    </ConfirmationDialog>
  );
};
